import {
    GET_PO_DETAILS, PO_DETAILS_ERROR,
    GET_PO_SEARCH, PO_SEARCH_ERROR,
    // POST_PO_LINEITEMS,
    POST_PO_LINEITEMS_ERROR,
    // INSPECTION_DASHBOARD,
    INSPECTION_DASHBOARD_ERROR,
    GET_SUPPLIER_POS, GET_SUPPLIER_POS_ERROR,
    GET_STAGES_BY_POLINEITEMID, GET_STAGES_BY_POLINEITEMID_ERROR,
    POST_CLAIM_PO, POST_CLAIM_PO_ERROR,
    POST_SAVE_LINE_ITEM_PO,
    POST_SAVE_LINE_ITEM_PO_ERROR,
    POST_SAVE_LINE_ITEM_PO_STAGE,
    POST_SAVE_LINE_ITEM_PO_STAGE_ERROR,
    POST_SEND_TO_VENDOR,
    POST_SEND_TO_VENDOR_ERROR,
    CHANGE_DOC_STATUS_CHANGE,
    CHANGE_DOC_STATUS_CHANGE_ERROR,
    POST_UNCLAIM_PO,
    POST_UNCLAIM_PO_ERROR,
    POST_PO_SEARCH,
    POST_PO_SEARCH_ERROR,
    POST_SEND_COMMENT,
    POST_SEND_COMMENT_ERROR,
    POST_EDIT_STAGE,
    POST_EDIT_STAGE_ERROR,
    PO_ACCEPTANCE_TO_PO,
    PO_ACCEPTANCE_TO_PO_ERROR,
    GET_DOCUMENT_FOR_ADVANCE,
    GET_DOCUMENT_FOR_ADVANCE_ERROR,
    POST_POACCEPTANCE_DOCUMENT_APPROVAL,
    POST_POACCEPTANCE_DOCUMENT_APPROVAL_ERROR,
    POST_UPDATE_DOCUMENTID_FOR_ADAVANCE,
    POST_UPDATE_DOCUMENTID_FOR_ADAVANCE_ERROR,
    POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS,
    POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS_ERROR,
    POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT,
    POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT_ERROR,
    GET_PAYMENT_TERM_DETAILS,
    GET_PAYMENT_TERM_DETAILS_ERROR,
    GET_ALL_PO_LIST_BY_USERID,
    GET_ALL_PO_LIST_BY_USERID_ERROR,
    GET_POLINEITEM_BY_POID,
    GET_POLINEITEM_BY_POID_ERROR,
    GET_PAYMENT_TERM_DOCUMENTS,
    GET_PAYMENT_TERM_DOCUMENTS_ERROR,
    UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE,
    UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE_ERROR,
    POST_CLAIM_PO_FOR_EXPEDITOR,
    POST_CLAIM_PO_FOR_EXPEDITOR_ERROR,
    POST_UNCLAIM_PO_FOR_EXPEDITOR,
    POST_UNCLAIM_PO_FOR_EXPEDITOR_ERROR,
    GET_PO_AND_POLINEITEMS_SEARCH,
    GET_PO_AND_POLINEITEMS_SEARCH_ERROR,
    REMOVE_LINE_ITEM_PO_STAGE,
    REMOVE_LINE_ITEM_PO_STAGE_ERROR,
    GET_PAYMENT_TERM_DETAILS_BY_PO_ID,
    GET_PAYMENT_TERM_DETAILS_BY_PO_ID_ERROR,
    GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS,
    GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS_ERROR,
    GET_PAYMENT_TERM_SEARCH,
    GET_PAYMENT_TERM_SEARCH_ERROR,
    PROJECT_ALLOCATION_DATA,
    PROJECT_ALLOCATION_DATA_ERROR,
    GET_PROJECT_ALLOCATION_DETAILS,
    GET_PROJECT_ALLOCATION_DETAILS_ERROR,
    SUBMIT_INVOICE_DOCUMENTS,
    SUBMIT_INVOICE_DOCUMENTS_ERROR,
    SUBMIT_INVOICE_DOCUMENTS_PARTIAL,
    SUBMIT_INVOICE_DOCUMENTS_PARTIAL_ERROR,
    UPDATE_PARTIAL_DOCUMENT_STATUS,
    UPDATE_PARTIAL_DOCUMENT_STATUS_ERROR,
    POST_ADDITIONAL_EMAILID,
    POST_ADDITIONAL_EMAILID_ERROR,
    GET_EXCEL_EXPORT_DATA,
    GET_EXCEL_EXPORT_DATA_ERROR,
    GET_DRAFT_DOCUMENTS,
    GET_DRAFT_DOCUMENTS_ERROR,
    GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS,
    GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS_ERROR,
    REQUEST_PAYMENT_FOR_LOGISTICS,
    REQUEST_PAYMENT_FOR_LOGISTICS_ERROR,
    GET_ALL_GRNS,
    GET_ALL_GRNS_ERROR,
    GET_ALL_GRN_EXPORT,
    GET_ALL_GRNS__EXPORT_ERROR,
    GET_POLINEITEMS_FOR_SAMETEMPLATE,
    GET_POLINEITEMS_FOR_SAMETEMPLATE_ERROR,
    GET_SAME_STAGES_BYLINEITEMID,
    GET_SAME_STAGES_BYLINEITEMID_ERROR,
    UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT,
    UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT_ERROR,
    GET_PROJECT_ALLOCATION_BY_USERID,
    GET_PROJECT_ALLOCATION_BY_USERID_ERROR,
    GET_DOCUMENT_FOR_QA,
    GET_DOCUMENT_FOR_QA_ERROR,
    GET_QADOCUMENT_BY_POLINEITEMID,
    GET_QADOCUMENT_BY_POLINEITEMID_ERROR,
    GET_QA_ACTIVITY,
    GET_QA_ACTIVITY_ERROR,
    POST_NON_PO,
    POST_NON_PO_ERROR,
    GET_PO_LINEITEM_DETAILS,
    GET_PO_LINEITEM_DETAILS_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';
import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

// const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

export const getPODetails = (id) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}po/${id}`)
        dispatch({
            type: GET_PO_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getPOSearch = (data) => async dispatch => {

    try {
        const res = await axios(
            {
                method: "post",
                url: `${ROOT_URL}po/search`,
                data: data,
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
        dispatch({
            type: GET_PO_SEARCH,
            payload: res.data
        })

    }
    catch (e) {
        dispatch({
            type: PO_SEARCH_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetPOAndPOLineItemSummary = (searchData) => async dispatch => {

    try {
        const res = await axios(
            {
                method: "post",
                url: `${ROOT_URL}po-and-polineItems/search`,
                data: searchData,
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
        dispatch({
            type: GET_PO_AND_POLINEITEMS_SEARCH,
            payload: res.data
        })

    }
    catch (e) {
        dispatch({
            type: GET_PO_AND_POLINEITEMS_SEARCH_ERROR,
            payload: console.log(e),
        })
    }

}

export const postPOLineItem = (form) => async dispatch => {
    console.log(form, 'from')
    //const id = 
    // const lineitemid = form.PurchaseOrderLineId

    try {
        // const res = await axios.post(`${ROOT_URL}po/${id}/lineitems/${lineitemid}`)
        // dispatch( {
        //     type: POST_PO_LINEITEMS,
        //     payload: res.data
        // })
        //console.log(res.data,'from')  
    }
    catch (e) {
        dispatch({
            type: POST_PO_LINEITEMS_ERROR,
            payload: console.log(e),
        })
    }

}

export const inspectionDashboard = () => async dispatch => {


    try {
        //const res = await axios.post(`${ROOT_URL}po/${id}/lineitems/${lineid}`)
        // dispatch( {
        //     type: INSPECTION_DASHBOARD,
        //     payload: res.data

        // })
        //console.log(res.data,'from')  
    }
    catch (e) {
        dispatch({
            type: INSPECTION_DASHBOARD_ERROR,
            payload: console.log(e),
        })
    }

}

export const getstagesByPOLineitemID = (id, lineitemid) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}po/${id}/lineitems/${lineitemid}/stages`)
        dispatch({
            type: GET_STAGES_BY_POLINEITEMID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_STAGES_BY_POLINEITEMID_ERROR,
            payload: console.log(e),
        })
    }

}

/*/po/:id/stages*/

export const GetDocumentsForAdvance = (id) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}po/${id}/stages`)
        console.log(res.data)
        dispatch({
            type: GET_DOCUMENT_FOR_ADVANCE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_FOR_ADVANCE_ERROR,
            payload: console.log(e),
        })
    }

}

export const getSupplierPOs = (id) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}vendor/2/po`)
        dispatch({
            type: GET_SUPPLIER_POS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_SUPPLIER_POS_ERROR,
            payload: console.log(e),
        })
    }

}

export const postClaimPO = (purchaseOrderId, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${purchaseOrderId}/claim`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
            // headers: {
            // 'Content-Type': 'multipart/form-data',
            // },
        })
        dispatch({
            type: POST_CLAIM_PO,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_CLAIM_PO_ERROR,
            payload: console.log(e),
        })
    }

}

export const postUnClaimPO = (purchaseOrderId, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${purchaseOrderId}/unclaim`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_UNCLAIM_PO,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_UNCLAIM_PO_ERROR,
            payload: console.log(e),
        })
    }

}

export const postSaveStagesForLineItemPO = (id, lineitemid, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'patch',
            url: `${ROOT_URL}po/${id}/lineitems/${lineitemid}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_SAVE_LINE_ITEM_PO,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_SAVE_LINE_ITEM_PO_ERROR,
            payload: console.log(e),
        })
    }

}

export const requestForVendorApproval = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/send-to-vendor`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        swal(res.data.message, { icon: "success" });
        dispatch({
            type: POST_SEND_TO_VENDOR,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_SEND_TO_VENDOR_ERROR,
            payload: console.log(e),
        })
    }
}

export const changeDocStatus = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/change-doc-status`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        swal(res.data.message, { icon: "success" });
        dispatch({
            type: CHANGE_DOC_STATUS_CHANGE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: CHANGE_DOC_STATUS_CHANGE_ERROR,
            payload: console.log(e),
        })
    }
}

export const getSearchedPO = (searchTerm) => async dispatch => {
    var data = {
        SearchTerm: searchTerm
    }
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/searchby`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_PO_SEARCH,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_PO_SEARCH_ERROR,
            payload: console.log(e),
        })
    }

}

export const postComment = (comment) => async dispatch => {
    var data = {
        stageDocumentId: comment.stageDocumentId,
        // comments: comment.comments,
        // status: comment.status,
        // actedBy: comment.actedBy,
        // isSMS: comment.isSMS,
        purchaseOrderId: comment.purchaseOrderId,
        purchaseLIneItemID: comment.purchaseLIneItemID,
        status: comment.status,
        uploadId: comment.uploadId,
        comment: comment.comment,
        documentTypeId: comment.DocumentTypeId,
        isSMS: comment.IsSMS,
        commentedBy: comment.commentedBy,
        actedBy: comment.actedBy
    }


    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/po/${comment.purchaseOrderId}/lineitems/${comment.purchaseLIneItemID}/Documents/${comment.stageDocumentId}`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_SEND_COMMENT,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_SEND_COMMENT_ERROR,
            payload: console.log(e),
        })
    }

}

export const postEditStagesForLineItemPO = (id, lineitemid, data) => async dispatch => {
    try {
        var dataToServer = {
            name: data.name,
            lineItemId: lineitemid.lineItemId,
            stages: data.stages,
            templateId: data.templateId,
            seqNo: data.seqNo,
            stageId: data.stageId,
            customStages: data.customStages,
            previousTemplateId: lineitemid.previousTemplateId
        }

        console.log(dataToServer, "dataToServer")
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/po/${id}/lineitems/${lineitemid.lineItemId}/edit`,
            data: dataToServer,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_EDIT_STAGE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_EDIT_STAGE_ERROR,
            payload: console.log(e),
        })
    }

}
export const postMapPOAcceptanceToPO = (versionId, documentId, poID, Comments, clickedCondition) => async dispatch => {
    try {
        var dataToServer = {
            documentId: documentId,
            versionId: versionId,
            poId: poID,
            Comments: Comments,
            clickedCondition: clickedCondition
        }

        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/po/mapPOAcceptanceToPO`,
            data: dataToServer,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: PO_ACCEPTANCE_TO_PO,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_ACCEPTANCE_TO_PO_ERROR,
            payload: console.log(e),
        })
    }

}

export const postApprovePOAcceptance = (data) => async dispatch => {

    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/accept-trail-sms`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_POACCEPTANCE_DOCUMENT_APPROVAL,
            payload: res.data
        })

    }
    catch (e) {
        dispatch({
            type: POST_POACCEPTANCE_DOCUMENT_APPROVAL_ERROR,
            payload: console.log(e),
        })
    }

}


export const postMapPOAcceptanceDocumentsToPO = (versionId, documentId, poID) => async dispatch => {
    try {
        var dataToServer = {
            documentId: documentId,
            versionId: versionId,
            poId: poID,
        }

        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/po/mapPOAcceptanceToPO`,
            data: dataToServer,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: PO_ACCEPTANCE_TO_PO,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PO_ACCEPTANCE_TO_PO_ERROR,
            payload: console.log(e),
        })
    }

}

export const postMapAdvanceDocumentIDsToPO = (params) => async dispatch => {
    try {

        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/updateAdvanceDocumentID`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_UPDATE_DOCUMENTID_FOR_ADAVANCE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_UPDATE_DOCUMENTID_FOR_ADAVANCE_ERROR,
            payload: console.log(e),
        })
    }

}

// For updating PO Advance document status
export const postUpdateAdvanceDocumentStatus = (AdvanceStageDocumentMappingId, ActedGroupId, POId, documentTypeId, approvalStatus, approvedBy, approvedByName, approvedOn, PaymentType, TypeFor, DocumentId) => async dispatch => {
    try {

        var dataToServer = {
            AdvanceStageDocumentMappingId: AdvanceStageDocumentMappingId,
            ActedGroupId: ActedGroupId,
            POId: POId,
            documentTypeId: documentTypeId,
            approvalStatus: approvalStatus,
            approvedBy: approvedBy,
            approvedByName: approvedByName,
            approvedOn: approvedOn,
            PaymentType: PaymentType,
            TypeFor: TypeFor,
            DocumentId: DocumentId,

        }
        console.log(POId, documentTypeId, approvalStatus, "data")
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/updateAdvanceDocumentStatus`,
            data: dataToServer,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_CHANGE_APPROVAL_STATUS_ADVANCE_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }

}

// update documentId for Payment Acknowledgement
export const postMapPaymentAcknowledgementDocumentIDsToInvoice = (InvoiceId, InvoiceNo = '', uploadedBy, paymentDate, paymentAcknowledgementDocumentId, utrNo, PaymentInformationNo = '') => async dispatch => {
    try {

        var dataToServer = {
            InvoiceId: InvoiceId,
            InvoiceNo: InvoiceNo,
            uploadedBy: uploadedBy,
            paymentDate: paymentDate,
            paymentAcknowledgementDocumentId: paymentAcknowledgementDocumentId,
            utrNo: utrNo,
            PaymentInformationNo: PaymentInformationNo,
        }
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/updatePaymentAcknowledgementDocumentID`,
            data: dataToServer,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_UPDATE_DOCUMENTID_FOR_ADAVANCE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_UPDATE_DOCUMENTID_FOR_ADAVANCE_ERROR,
            payload: console.log(e),
        })
    }

}

export const postDocumentIDForPODetailsDocument = (data) => async dispatch => {

    // var params = {
    //     DocumentId: data.DocumentId,
    //     PoID: data.PoID,
    //     UploadedBy: data.UploadedBy
    // }

    console.log("recieved in store ", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}postDocumentIDForPODetailsDocument`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_DOCUMENTID_FOR_PODETAILS_DOCUMENT_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetPaymentTermDetails = (PaymentTermId) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}/getPaymentTermDetails/${PaymentTermId}`)
        dispatch({
            type: GET_PAYMENT_TERM_DETAILS,
            payload: res.data
        })
    }

    catch (e) {
        dispatch({
            type: GET_PAYMENT_TERM_DETAILS_ERROR,
            payload: console.log(e),
        })
    }

}

export const getPaymentTermDocuments = (PoId) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}getPaymentTermDocuments/${PoId}`)
        dispatch({
            type: GET_PAYMENT_TERM_DOCUMENTS,
            payload: res.data
        })
    }

    catch (e) {
        dispatch({
            type: GET_PAYMENT_TERM_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetAllPOListByUserId = (userid) => async dispatch => {
    if (userid == null)
        userid = 0
    try {

        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}po/getAllPOListByUserId/${userid}`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_ALL_PO_LIST_BY_USERID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_PO_LIST_BY_USERID_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetPOLineItemByPOId = (PurchaseOrderId, input) => async dispatch => {
    // var params = {
    //     PurchaseOrderId: data.PurchaseOrderId,
    // }

    try {
        const res = await axios.get(`${ROOT_URL}po/getPOLineItemByPOId/${PurchaseOrderId}`)
        dispatch({
            type: GET_POLINEITEM_BY_POID,
            payload: res.data,
            data: input
        })
    }
    catch (e) {
        dispatch({
            type: GET_POLINEITEM_BY_POID_ERROR,
            payload: console.log(e),
        })
    }

}
// export const getPaymentTermDocuments = (PoId) => async dispatch => {

export const UpdatePoStatusforPOacceptanceRequest = (poid, Status, DocumentId, versionId) => async dispatch => {
    // var input= {
    //     DocumentId: DocumentId,
    //     versionId: versionId
    // }
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}updatePoStatusForPoAcceptanceRequest/${poid}/${Status}/${DocumentId}/${versionId}`,
            // data: input,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_PO_STATUS_FOR_REQUEST_PO_ACCEPTANCE_ERROR,
            payload: console.log(e),
        })
    }
}


export const postClaimPOByExpeditor = (purchaseOrderId, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${purchaseOrderId}/claimPOByExpeditor`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
            // headers: {
            // 'Content-Type': 'multipart/form-data',
            // },
        })
        dispatch({
            type: POST_CLAIM_PO_FOR_EXPEDITOR,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_CLAIM_PO_FOR_EXPEDITOR_ERROR,
            payload: console.log(e),
        })
    }

}

export const postUnClaimPOByExpeditor = (purchaseOrderId, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${purchaseOrderId}/unClaimPOByExpediting`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_UNCLAIM_PO_FOR_EXPEDITOR,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_UNCLAIM_PO_FOR_EXPEDITOR_ERROR,
            payload: console.log(e),
        })
    }

}

export const postAddStage = (id, lineitemid, data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${id}/lineitems/${lineitemid}/stage`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_SAVE_LINE_ITEM_PO_STAGE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_SAVE_LINE_ITEM_PO_STAGE_ERROR,
            payload: console.log(e),
        })
    }
}
export const removeStage = (id, lineitemid, qATemplateStageId) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/${id}/lineitems/${lineitemid}/remove-stage`,
            data: {
                qATemplateStageId: qATemplateStageId
            },
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: REMOVE_LINE_ITEM_PO_STAGE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: REMOVE_LINE_ITEM_PO_STAGE_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPaymentTermDetailByPOId = (id) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}po-payment-term-details/${id}`)
        dispatch({
            type: GET_PAYMENT_TERM_DETAILS_BY_PO_ID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_PAYMENT_TERM_DETAILS_BY_PO_ID_ERROR,
            payload: console.log(e),
        })
    }

}
export const PaymentTermDocumentsApprovalByPMs = (POId) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}${POId}/tpm-cpm-approval-details`)
        dispatch({
            type: GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_APPROVAL_DETAILS_BY_TPM_OR_CPM_FOR_PAYMENT_TERM_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetDocumentsFromPaymentTermsByPoIdMultiple = (inputData) => async dispatch => {
    try {
        const res = await axios(
            {
                method: "post",
                url: `${ROOT_URL}payment-term-documents/search`,
                data: inputData,
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
        dispatch({
            type: GET_PAYMENT_TERM_SEARCH,
            payload: res.data
        })

    }
    catch (e) {
        dispatch({
            type: GET_PAYMENT_TERM_SEARCH_ERROR,
            payload: console.log(e),
        })
    }
}


export const PurchaseOrderAllocationDetails = (inputData) => async dispatch => {
    try {
        const res = await axios(
            {
                method: "post",
                url: `${ROOT_URL}project-allocation`,
                data: inputData,
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
        dispatch({
            type: PROJECT_ALLOCATION_DATA,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PROJECT_ALLOCATION_DATA_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetPurchaseOrderAllocation = (input) => async dispatch => {
    try {
        const res = await axios(
            {
                method: "post",
                url: `${ROOT_URL}/get-project-allocation-details`,
                data: input,
                headers: {
                    'content-type': 'application/json',
                }
            }
        )
        dispatch({
            type: GET_PROJECT_ALLOCATION_DETAILS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_PROJECT_ALLOCATION_DETAILS_ERROR,
            payload: console.log(e),
        })
    }
}

export const submitInvoiceDocuments = (data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/submit-invoice-documents`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: SUBMIT_INVOICE_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: SUBMIT_INVOICE_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }
}
export const UpdatePartialPaymentDetails = (data) => async dispatch => {
    try {
        //const res = await axios.get(`${ROOT_URL}/po/${purchaseOrderId}/claim`)
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/submit-partial-documents-payments`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: SUBMIT_INVOICE_DOCUMENTS_PARTIAL,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: SUBMIT_INVOICE_DOCUMENTS_PARTIAL_ERROR,
            payload: console.log(e),
        })
    }
}
export const UpdateApprovalForAdvanceDocumentPartial = (data, PurchaseOrderId = 0) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/update-partial-documents-payments`,
            data: {
                ...data,
                PurchaseOrderId: PurchaseOrderId
            },
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_PARTIAL_DOCUMENT_STATUS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_PARTIAL_DOCUMENT_STATUS_ERROR,
            payload: console.log(e),
        })
    }
}
export const postAdditionalEmailId = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}po/additional-email-id`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_ADDITIONAL_EMAILID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: POST_ADDITIONAL_EMAILID_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetDraftDocuments = (PoId) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}po/${PoId}/get-draft-documents`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_DRAFT_DOCUMENTS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DRAFT_DOCUMENTS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetExcellExportData = () => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}get-excell-export-data`,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_EXCEL_EXPORT_DATA,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_EXCEL_EXPORT_DATA_ERROR,
            payload: console.log(e),
        })
    }
}
export const RequestPayemtForLogistics = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}request-payment-for-logistics`,
            data: input,
            headers: {
                'content-type': 'application/json',
            },
        })
        dispatch({
            type: REQUEST_PAYMENT_FOR_LOGISTICS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: REQUEST_PAYMENT_FOR_LOGISTICS_ERROR,
            payload: console.log(e),
        })
    }
}
export const LogistcsPOsAndLineItem = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-po-polineitem-for-logistics`,
            headers: {
                'content-type': 'application/json',
            },
            data: input
        })
        dispatch({
            type: GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_PO_AND_LINITEM_DETAILS_FOR_LOGISTICS_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetGRNDetails = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-all-GRNs`,
            data: input,
            headers: {
                'content-type': 'application/json',
            },
        })
        dispatch({
            type: GET_ALL_GRNS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_GRNS_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetGRNExport = () => async dispatch => {
    let allData = [];
    let offset = 0;
    const limit = 100000;
    let totalCount = 0;

    try {
        // Fetch data in chunks until all data is retrieved
        while (true) {
            const res = await axios.get(`${ROOT_URL}get-all-GRNs-export`, {
                params: {
                    limit,
                    offset
                }
            });
            const { totalCount: resTotalCount, chunkData } = res.data;

            // If totalCount is not set yet, set it
            if (totalCount === 0) {
                totalCount = resTotalCount;
            }

            allData = allData.concat(chunkData);
            offset += limit;

            // Break loop if all data is fetched
            if (offset >= totalCount) {
                break;
            }
        }

        // Dispatch action with all fetched data
        dispatch({
            type: GET_ALL_GRN_EXPORT,
            payload: allData
        });
    } catch (e) {
        dispatch({
            type: GET_ALL_GRNS__EXPORT_ERROR,
            payload: console.log(e)
        });
    }
};




export const GetPOLineItemsForSameTemplate = (poId) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-POLineItems-For-SameTemplate`,
            data: { poId: poId },
            headers: {
                'content-type': 'application/json',
            },
        })
        dispatch({
            type: GET_POLINEITEMS_FOR_SAMETEMPLATE,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_POLINEITEMS_FOR_SAMETEMPLATE_ERROR,
            payload: console.log(e),
        })
    }
}
export const GetSameTemplateDetilsByPolineiTemId = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-same-stages-by-polinneitemId`,
            data: { poLineItemId: data },
            headers: {
                'content-type': 'application/json',
            },
        })
        dispatch({
            type: GET_SAME_STAGES_BYLINEITEMID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_SAME_STAGES_BYLINEITEMID_ERROR,
            payload: console.log(e),
        })
    }
}

export const UpdateDocIdForMultipleStagesByPOLineItemId = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}update-document-id`,
            data: data,
            headers: {
                'content-type': 'application/json',
            },
        })
        dispatch({
            type: UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_DOCUMENT_ID_FOR_MULTIPLE_STAGE_DOCUMENT_ERROR,
            payload: console.log(e),
        })
    }
}
export const getProjectAllocationByUserId = (input) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}get-project-allocation-by-user`,
            headers: {
                'content-type': 'application/json',
            },
            data: input,
        })
        dispatch({
            type: GET_PROJECT_ALLOCATION_BY_USERID,
            payload: res.data,
        })
    } catch (e) {
        dispatch({
            type: GET_PROJECT_ALLOCATION_BY_USERID_ERROR,
            payload: console.log(e),
        })
    }
}

export const GetDocumentsForQA = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/qa-documents`)
        console.log(res.data)
        dispatch({
            type: GET_DOCUMENT_FOR_QA,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_FOR_QA_ERROR,
            payload: console.log(e),
        })
    }

}

export const getQADocumentsByParams = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/qa-documents`, params)
        console.log(res.data)
        dispatch({
            type: GET_QADOCUMENT_BY_POLINEITEMID,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_QADOCUMENT_BY_POLINEITEMID_ERROR,
            payload: console.log(e),
        })
    }

}
export const postQADocumentForPOLineitemID = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/upload-qa-documents-for-po`, params)
        console.log(res.data)
        // dispatch({
        //     type: GET_DOCUMENT_FOR_QA,
        //     payload: res.data
        // })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_FOR_QA_ERROR,
            payload: console.log(e),
        })
    }

}

export const updateQADocumentStatus = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/update-qa-documents-status`, params)
        console.log(res.data)
        // dispatch({
        //     type: GET_DOCUMENT_FOR_QA,
        //     payload: res.data
        // })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_FOR_QA_ERROR,
            payload: console.log(e),
        })
    }

}

export const updateQAActivity = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/update-qa-activity`, params)
        console.log(res.data)
        // dispatch({
        //     type: GET_DOCUMENT_FOR_QA,
        //     payload: res.data
        // })
    }
    catch (e) {
        dispatch({
            type: GET_DOCUMENT_FOR_QA_ERROR,
            payload: console.log(e),
        })
    }

}

export const getQAActivity = (params) => async dispatch => {

    try {
        const res = await axios.post(`${ROOT_URL}po/get-qa-activity`, params)
        console.log(res.data)
        dispatch({
            type: GET_QA_ACTIVITY,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_QA_ACTIVITY_ERROR,
            payload: console.log(e),
        })
    }

}
export const postNonPODetails = (params) => async dispatch => {

    // try {
        await axios.post(`${ROOT_URL}po/add-non-po-details`, params)
        .then((res) => {
            console.log(res.data)
            dispatch({
                type: POST_NON_PO,
                payload: res.data
            })
            dispatch({
                type: POST_NON_PO_ERROR,
                payload: [],
            })
        })
        .catch((e) => {
            console.log(e.response, "this.props.nonPODetailsError")
            dispatch({
                type: POST_NON_PO_ERROR,
                payload: e.response.data,
            })
        })
    // }
    // catch (e) {
    // }
}

export const getPODetailsWithPoLineItemId = (params) => async dispatch => {
    console.log('params===', params);
        try {
            const res = await axios.post(`${ROOT_URL}po/get-PO-Details-With-Po-LineItem-Id`, params)
            console.log('res.data', res.data)
            dispatch({
                type: GET_PO_LINEITEM_DETAILS,
                payload: res.data
            })
        }
        catch (e) {
            dispatch({
                type: GET_PO_LINEITEM_DETAILS_ERROR,
                payload: console.log(e),
            })
        }
}